import { Trash2, Clock } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'
import { Badge } from '@/shared/components/ui/badge'
import { ScrollArea } from '@/shared/components/ui/scroll-area'
import { useHistory } from '../hooks/useHistory'
import { useRedactorStore } from '../store/redactorStore'

export function RedactorHistory() {
  const { history, loading, remove } = useHistory()
  const { setInputText, setTone, setAudience, setMessageType } = useRedactorStore()

  const loadItem = (item: (typeof history)[number]) => {
    setInputText(item.originalText)
    setTone(item.tone)
    setAudience(item.audience)
    setMessageType(item.messageType)
  }

  if (loading) {
    return (
      <div className="flex flex-col gap-2 animate-pulse">
        {[1, 2, 3].map((i) => (
          <div key={i} className="h-16 w-full rounded-md bg-muted" />
        ))}
      </div>
    )
  }

  if (!history.length) {
    return (
      <p className="text-sm text-muted-foreground italic">
        No history yet. Redact a message to see it here.
      </p>
    )
  }

  return (
    <ScrollArea className="max-h-[400px]">
      <div className="flex flex-col gap-2 pr-2">
        {history.map((item) => (
          <div
            key={item.id}
            className="group relative flex flex-col gap-1 rounded-md border bg-card p-3 text-sm hover:bg-accent/50 transition-colors cursor-pointer"
            onClick={() => loadItem(item)}
          >
            <div className="flex items-center gap-2">
              <Clock className="h-3 w-3 text-muted-foreground" />
              <span className="text-xs text-muted-foreground">
                {new Date(item.createdAt).toLocaleString()}
              </span>
              <div className="ml-auto flex gap-1">
                <Badge variant="outline" className="text-xs">{item.tone}</Badge>
                <Badge variant="outline" className="text-xs">{item.messageType}</Badge>
              </div>
            </div>
            <p className="line-clamp-2 text-muted-foreground text-xs">
              {item.originalText}
            </p>
            <Button
              variant="ghost"
              size="icon"
              className="absolute right-2 top-2 h-6 w-6 opacity-0 group-hover:opacity-100 transition-opacity"
              onClick={(e) => {
                e.stopPropagation()
                void remove(item.id)
              }}
            >
              <Trash2 className="h-3 w-3" />
            </Button>
          </div>
        ))}
      </div>
    </ScrollArea>
  )
}
